import { createGlobalStyle } from 'styled-components';

/**
 * Links — yellow accent only (with primary buttons).
 * Nav uses `.item` and keeps its own colors in TopMenuStyled.
 */
export const GlobalLinksStyled = createGlobalStyle`
    a:not(.item):not(.btn):not(.nav-link):not(.dropdown-item) {
        color: var(--color-accent);
        font-weight: 600;
        text-decoration: none;
        transition: color 0.15s ease;

        &:hover {
            color: var(--color-yellow-light);
        }

        &:focus-visible {
            outline: 2px solid var(--color-accent);
            outline-offset: 2px;
        }
    }

    a.btn {
        text-decoration: none;
    }
`;
